<template>
  <div>
    <div class="common-header-wrap">
      <mt-header class="common-header" :title="$route.query.category_title || $t('search.result')">
        <mt-button icon="back" slot="left" @click="resetCommonStoreList();$router.push({ name: 'MemberO2oErrand' })"></mt-button>
      </mt-header>
    </div>
    <div class="header" :class="orderNum > 0 && $route.name!=='HomeWaimaiIndex' ? 'orderTop' : 'originTop' ">
      <home-common-search :value="params.keyword" :showAddress="false" class="search-wrapper"></home-common-search>
    </div>
    <common-store-list />
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import HomeCommonSearch from '../common/HomeCommonSearch'
import CommonStoreList from '../common/CommonStoreList'
export default {
  name: 'HomeStorelist',
  components: {
    HomeCommonSearch,
    CommonStoreList
  },
  data () {
    return {
      params: {
        keyword: this.$route.query.keywords ? this.$route.query.keywords : ''
      }

    }
  },
  computed: {
    ...mapState({
      orderNum: (state) => state.member.orderNum,
    }),
  },
  methods: {
    ...mapMutations({
      resetCommonStoreList: 'resetCommonStoreList'
    })
  }
}
</script>

<style scoped>
  .header{height:2.4rem;
    color: #fff;
    /* background:#f4c41e; */
    display:flex;
    justify-content: center;
    }
  /* .header .kongbai{width: 2rem;} */

  .header .search-wrapper{
    /* flex:1; */
    width: 90%;
    padding-top:.5rem;
    padding:.5rem 0px .35rem 0px
  }
  .header .search-wrapper input{border-radius:50%}
</style>
